import {Auth, API, graphqlOperation } from "aws-amplify";
import cardApi from '../api/cardApi'
import {createOwnedCard, updateOwnedCard} from  '../graphql/mutations'
import { Storage } from "aws-amplify";
import _ from 'lodash'
export const CardGridActions = {
    getUserGrid,
    addCard,
    selectGridItem,
    updateCard,
    fetchGallery,
    handleLogout,
    gridDataInit,
    getInitVals,
    sortGrid,
    applyAdditionalFilters,
    fetchState
}


function getSetArr(dataSet){
    let sets  = _.map(_.uniqBy(dataSet, 'completeSetId'), 'completeSetId')
    let forDeletion = ['false', undefined]
    return sets.filter(item => !forDeletion.includes(item))
}

function getUserGrid() {
    return async (dispatch) => {
        Auth.currentSession().then( async res=>{
            try {
                let authTok = res.getIdToken().jwtToken
                const options = {
                    headers: {
                        Authorization: authTok    
                    }
                }
                const response = await cardApi.get('/my/cards', options)
                response.data.sets = getSetArr(response.data)
                console.log(response.data.sets)
                dispatch({
                    type: 'OWNED_CARDS_RESPONSE',
                    payload: response.data,
                    userActive: await getUserLogin()
    
                })    
            }
            catch (e){}
        })
            
    }
}



function fetchGallery() {
    return async (dispatch) => {
            const response = await cardApi.get('/card/gallery')
            response.data.sets = getSetArr(response.data)
             dispatch({
                 type: 'OWNED_CARDS_RESPONSE',
                 payload: response.data,
                 userActive: await getUserLogin()
             })             
    }
}


function getInitVals() {
    return async (dispatch) => {
            const response = await cardApi.get('/init/vals')
             dispatch({
                 type: 'INIT_VALS_RESPONSE',
                 payload: _.orderBy(response.data, ['setName'], ['asc'])
             })             
    }
}


function fetchState() {
    return  {
        type: 'FETCH_STATE',
    }
}

function sortGrid(grid, column) {
    let selCardId = grid.cardGridData[grid.selectedCard].id  //get the ID of the selected card - pre sort
    let newDir = grid.sortDir === 'asc' ? 'desc' : 'asc'
    let newGrid = {}
    if (column !== "cardNum") {
        newGrid = {
            ...grid,
            cardGridData: _.orderBy(grid.cardGridData, column, newDir),
            sortDirection : newDir
        }
    }
    else {  //Sort CardNum Numerically 
        newGrid = {
            ...grid,
            cardGridData: _.orderBy(grid.cardGridData, (obj) => parseInt(obj.cardNum, 10), newDir),
            sortDirection : newDir
        }
    }
    let newSelCard = _.findIndex(newGrid.cardGridData, ['id', selCardId])
    console.log('after sort - selected card is ' + newSelCard)
    newGrid.selectedCard = newSelCard
    //POST Sort, update the selected Card ID based on its new position in the sorted set
    return {
        type: 'SORT_GRID_RESPONSE',
        payload: newGrid,
        sortDir: newDir
    }
}


function addCard(cardData) {
    return async (dispatch) => {
        console.log(' in action addCard' )
        try {
            //const label = 'CARD_' + cardData.year + '_' + cardData.setName.replace(' ', '_').toUpperCase() + '_' + cardData.cardNum
            let label = 'CARD_'  + cardData.setName.replaceAll(' ', '_').toUpperCase() + '_' + cardData.cardNum
            console.log('set is ' + cardData.setName)
            if (label.startsWith ('CARD_2009_ULTIMATE_COLLECTION')) {
                console.log('here')
                label = label.replace('_COLLECTION', '')
            }
            //2009 ULTIMATE_COLLECTION was loaded incorrectly - need to remove the '_COLLECTION' from the label for this set only

            console.log('LABEL IS ' + label)
            const cardRes = await API.graphql(graphqlOperation(createOwnedCard, {input: {...cardData, imageUrl: cardData.imageUrl.name, label}}));
            //Also need to upload the image
            const fileRes = await Storage.put(cardData.imageUrl.name, cardData.imageUrl, {contentType: "image/png"})
            console.log("UPLOAD RESULT " + JSON.stringify(fileRes) )
            dispatch({
                type: 'ADD_CARD_RESPONSE',
                payload: cardRes
            })    
        } catch (error) {
            console.log('error on adding card', error);
        }
            
    }
}




function updateCard(origCard, newValues) {
    return async (dispatch) => {
        const newCard = {...newValues, id: origCard.id}
        const cardRes = await API.graphql(graphqlOperation(updateOwnedCard, {input: {...newCard, imageUrl: newValues.imageUrl.name ? newValues.imageUrl.name : newValues.imageUrl, 
            completeSetId: newValues.completeSetId && newValues.completeSetId !== 'false' ? newValues.completeSetId : false}}));
        dispatch({
            type: 'UPDATE_CARD_RESPONSE',
            payload: cardRes
        })    
            
    }
}

function selectGridItem(idx) {
    return async (dispatch) => {
        let userLoggedIn = await getUserLogin()
        console.log('USER CHK ' + userLoggedIn)
        dispatch({
            type: 'SEL_CARD_CHANGE',
            payload: idx,
            userActive: userLoggedIn
        })    
    }
}

function gridDataInit() {
    return async (dispatch) => {
        dispatch({
            type: 'GRID_DATA_INIT'
        })    
    }
}

function applyAdditionalFilters(values) {
    return async (dispatch) => {
        dispatch({
            type: 'APPLY_FILTERS',
            payload: values

        })    
    }
}

function handleLogout() {
    return async (dispatch) => {
        await Auth.signOut()
         dispatch({
            type: 'USER_LOGOUT'
        })    
    }
}



async function getUserLogin () {
    let userDetails = {
        login: true
    }
        try {
            let userObj = await Auth.currentAuthenticatedUser()
            userDetails.userName = userObj.username
        }
        catch (e) {
            userDetails.login = false
        }
        console.log('USER STATS ' + JSON.stringify(userDetails))
        return userDetails
    }